import { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db, auth } from "./firebase.js"; // Adjust path as needed
import ProfileMenu from "./ProfileMenu.js";

export default function Profile({ setAllowed }) {
  const [showProfile, setShowProfile] = useState(false);
  const [showVerifyBadge, setShowVerifyBadge] = useState(false);

  useEffect(() => {
    const unsub = auth.onAuthStateChanged(async (user) => {
      if (user) {
        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          const data = userSnap.data();
          if (!data.report_csv) {
            setShowVerifyBadge(true);
          }
        }
      }
    });
    return unsub;
  }, []);
  return (
    <div>
      <button
        onClick={() => setShowProfile(!showProfile)}
        className="relative text-blue-600 hover:underline"
      >
        Profile
        {showVerifyBadge && (
          <span className="ml-2 text-xs text-white bg-green-600 px-2 py-0.5 rounded-full animate-pulse">
            Verify your profile
          </span>
        )}
      </button>

      {showProfile && (
        <div className="absolute left-1/2 transform -translate-x-1/2 mt-4 w-[90vw] max-w-2xl bg-white shadow-lg border rounded p-6 z-50 text-left overflow-y-auto max-h-[80vh]">
          <button
            onClick={() => setShowProfile(false)}
            className="absolute top-2 right-2 text-gray-500 hover:text-black text-lg"
          >
            ×
          </button>
          <ProfileMenu />
        </div>
      )}
    </div>
  );
}
